import { render, staticRenderFns } from "./UjetRecordingsTable.vue?vue&type=template&id=00161f67&"
import script from "./UjetRecordingsTable.vue?vue&type=script&lang=js&"
export * from "./UjetRecordingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports